import { z } from "zod";

export const equipmentScheme = z.object({
  equipment: z.array(z.object({
    count: z.number(),
    range: z.number(),
    id: z.number(),
    imageUrl: z.string().nullable(),
    title: z.string(),
    pricePerUnit: z.number(),
    isFixedPrice: z.boolean().optional().default(false),
  })),
});

export type EquipmentFormScheme = z.infer<typeof equipmentScheme>;
